/**
 * Modal de confirmação reutilizável usando Bootstrap Modal por baixo.
 * Substitui window.confirm() — visual consistente com o resto da UI,
 * suporta variantes (primary/danger/warning) e mensagens multi-linha.
 *
 * Uso:
 *   const ok = await confirmDialog({
 *     title: 'Remover corretora',
 *     message: 'Tem certeza?\n\nAs credenciais serão apagadas.',
 *     confirmLabel: 'Remover',
 *     confirmVariant: 'danger'
 *   });
 *   if (!ok) return;
 *
 * Fallback: se Bootstrap não estiver disponível (SSR, testes), cai pro
 * window.confirm nativo — evita travar a UI por causa de bug de carregamento.
 */

let counter = 0;

function _escapeHtml(s) {
    return String(s == null ? '' : s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

export function confirmDialog({
    title = 'Confirmar',
    message = 'Você tem certeza?',
    confirmLabel = 'Confirmar',
    cancelLabel = 'Cancelar',
    confirmVariant = 'primary'
} = {}) {
    return new Promise(resolve => {
        if (!window.bootstrap || !window.bootstrap.Modal) {
            // Defensivo: se Bootstrap JS não carregou, não trava a UI
            // eslint-disable-next-line no-alert
            resolve(window.confirm(message));
            return;
        }

        const id = `confirmDialog_${++counter}`;
        const html = `
        <div class="modal fade" id="${id}" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">${_escapeHtml(title)}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
                    </div>
                    <div class="modal-body" style="white-space: pre-wrap;">${_escapeHtml(message)}</div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-cancel>${_escapeHtml(cancelLabel)}</button>
                        <button type="button" class="btn btn-${confirmVariant}" data-confirm>${_escapeHtml(confirmLabel)}</button>
                    </div>
                </div>
            </div>
        </div>`;

        const wrapper = document.createElement('div');
        wrapper.innerHTML = html.trim();
        const modalEl = wrapper.firstElementChild;
        document.body.appendChild(modalEl);

        const modal = new window.bootstrap.Modal(modalEl, { backdrop: 'static' });
        let result = false;

        modalEl.querySelector('[data-confirm]').addEventListener('click', () => {
            result = true;
            modal.hide();
        });
        modalEl.querySelector('[data-cancel]').addEventListener('click', () => {
            result = false;
            modal.hide();
        });

        modalEl.addEventListener('hidden.bs.modal', () => {
            modal.dispose();
            modalEl.remove();
            resolve(result);
        });

        modal.show();
    });
}
